@if (label() === true) {
  <div class="label-placeholder"></div>
} @else if (label()) {
  <onyx-input-label
    [label]="$any(label())"
    [hint]="hint()"
    [required]="required()"
    [disabled]="disabled()"
    (click)="focus()"
  ></onyx-input-label>
}

@let hasClear =
  (value().hour != null || value().minutes != null) && !disabled();
<div
  class="input size-{{ size() }}"
  [class.active]="value().hour != null || value().minutes != null"
  [class.invalid]="invalid()"
  [class.disabled]="disabled()"
  [class.clear]="hasClear"
  tabindex="-1"
  (click)="focusInputs($event)"
  (keydown)="(null)"
>
  <input
    [placeholder]="isTime() ? '00' : 'hh'"
    [disabled]="disabled()"
    (keypress)="validateInput($event, 23)"
    (input)="changeHour($event)"
    (paste)="pasteTime($event)"
    #inputElement
  />

  <div class="separator">:</div>

  <input
    [placeholder]="isTime() ? '00' : 'mm'"
    [disabled]="disabled()"
    [tabIndex]="value().hour != null ? 0 : -1"
    (keypress)="validateInput($event, 59)"
    (input)="changeMinutes($event)"
    (paste)="pasteTime($event)"
    (keydown.backspace)="value().minutes == null ? focusHoursInput() : null"
    (focus)="value().hour == null ? focusHoursInput() : null"
    #inputElement
  />

  <div class="actions">
    <div class="hidden">
      @if (hasClear) {
        <onyx-clear-button
          class="clear"
          (click)="clearValue(); $event.stopPropagation()"
        ></onyx-clear-button>
      }
    </div>
  </div>

  @if (showClockIcon()) {
    <onyx-icon
      class="clock"
      [name]="isTime() ? 'clock-outlined' : 'hourglass-top-filled'"
      [size]="20"
    ></onyx-icon>
  }
</div>
